import React from 'react'
import { Link } from 'react-router-dom'

function ExperienceSection() {
  return (
    <>
    <section className="ttm-row padding_top_zero-section margin_top90 res-991-margin_top0 bg-layer-equal-height ttm-bgcolor-grey clearfix">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-xs-12">
          <div className="padding_top90 res-991-padding_top60">
            {/* section title */}
            <div className="section-title">
              <div className="title-header">
                <h3>ABOUT NASK International</h3>
                <h2 className="title">The Leading Textile Brand in <b>Market</b></h2>
              </div>
              <div className="title-desc">
                <p> NASK International operates in the textile market as a manufacturer and trader. As years go by, the range of produced textiles has been increased,
                in addition to regular production, we have become one of the largest exporters.</p>
              </div>
            </div>{/* section title end */}
            <div className="row">
              <div className="col-sm-6">
                <ul className="ttm-list ttm-bordered-lists ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                  <li><i className="ti ti-check" /><span className="ttm-list-li-content">Current Market Trends</span></li>
                  <li><i className="ti ti-check" /><span className="ttm-list-li-content">Leading Rayon Fabric Wholesaler</span></li>
                  <li><i className="ti ti-check" /><span className="ttm-list-li-content">Global Fabric Distributor</span></li>
                </ul>
              </div>
              <div className="col-sm-6">
                <ul className="ttm-list ttm-bordered-lists ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                  <li><i className="ti ti-check" /><span className="ttm-list-li-content">Biologically Tested Fabrics</span></li>
                  <li><i className="ti ti-check" /><span className="ttm-list-li-content">Award-Winning Exporter</span></li>
                  <li><i className="ti ti-check" /><span className="ttm-list-li-content">Stable Partner in Global Textile Industry</span></li>
                </ul>
              </div>
            </div>
            <div className="margin_top20">
              <div className="d-inline-block">
                {/* <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-fill ttm-btn-color-skincolor margin_right20 margin_top15" href="about-us.html">view more</a> */}
                <Link className="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-dark  margin_top15" to="contact-us">contact us</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-8 col-sm-8">
          <div className="mt_160 text-md-right res-991-margin_top40">
            <div className="ttm_single_image-wrapper ttm_single_image_hover imagestyle-one res-991-margin_right0">
              <img className="img-fluid auto_size" src="images/single-img-02.jpg" alt="single-02" height={663} width={504} />
            </div>
          </div>
        </div>
      </div>{/* row end */}
    </div>
  </section>
  <section className="ttm-row service-section ttm-bgcolor-grey position-relative z-index-2 clearfix">
  <div className="container">
    {/* row */}
    <div className="row">
      <div className="col-lg-12">
        {/* section-title */}
        <div className="section-title title-style-center_text">
          <div className="title-header">
            <h3>INDUSTRIES &amp; PRODUCTION</h3>
            <h2 className="title">Let's Experience <b>Exclusive Quality</b></h2>
          </div>
        </div>{/* section-title end */}
      </div>
    </div>
    {/* row end */}
    <div className="row">
      <div className="col-lg-12">
        <div className="featuredbox-number">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-textile-1" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Contact &amp; Terms Finalization</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Please review and confirm your contact details and agreed terms to proceed.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-moisture-wicking-fabric" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Opening of Letter of Credit (L/C)</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Initiate the Letter of Credit (L/C) process according to the agreed terms and conditions.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-sewing-machine" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Development of the product</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Product development is progressing according to specifications and the agreed timeline.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-textile-1" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Nask International Inspections, Quality Audits &amp; Control</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Nask International conducts inspections, audits, and quality control to ensure superior standards.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-textile-1" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Completion of Order &amp; Final Inspection and Approval</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Order completion, final inspection, and approval are underway for quality assurance.
                    </p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-silk" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Preparation of Shipping Documents &amp; Working Papers</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Shipping documents and working papers are prepared for seamless processing.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-moisture-wicking-fabric" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Provision &amp; Enclosure of Documents (Bank, Customer and Shipping
                      Agency)</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Documents for the bank, customer, and shipping agency are enclosed for processing.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/*featured-icon-box*/}
              <div className="featured-icon-box icon-align-top-content style5">
                <i className="ttm-num ti-info" />
                <div className="featured-icon">
                  <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                    <i className="flaticon flaticon-sewing-machine" />
                  </div>
                </div>
                <div className="featured-content">
                  <div className="featured-title">
                    <h3>Shipment of Products/Consignment</h3>
                  </div>
                  <div className="featured-desc">
                    <p>Products and consignment are shipped and en route as scheduled.</p>
                  </div>
                </div>
              </div>{/* featured-icon-box end*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  
  )
}

export default ExperienceSection